import { sharedServices } from '../../core/services/shared';
import { userService } from './user';
import { middlewareService } from '../../shared/service';
import { utils } from "../../core/helpers/utils";

export const userProfileService = {
  getUserProfileDetails,
  getPlansList,
  getCurrentPlanDetails,
  getWallet,
  getPanlessHoldings,
  getValidPans,
  setDefaultPan,
  deleteAccount,
  activateAccount,
  editAccount,
  sendOtp,
  verifyOtp,
  setOrigin,
  assignPan,
  assignMultiPan,
  sentUserData
}

function getUserProfileDetails() {
  var promises = [];
  promises.push(sharedServices.getCanList());
  promises.push(userService.getUserProfile());
  promises.push(getValidPans());

  return Promise
    .all(promises)
    .then(function(response) {
      return {
        canDetails: response[0].data,
        userDetails: response[1],
        validPans: response[2]
      };
    })
    .catch(function(error) {
      console.log(error);
    });
}

function getPlansList() {
  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
  };

  return fetch(process.env.REACT_APP_API_URL + '/plan/list', requestOptions)
    .then(response => response.json())
    .then(result => {
      const plansResponse = utils.parsePayload(result);

      return plansResponse;
    });
}

function getCurrentPlanDetails() {
  var promises = [];
  promises.push(getCurrentPlan());
  promises.push(getTransactionLimits());

  return Promise
    .all(promises)
    .then(function(response) {
      return {
        currentPlan: response[0],
        transactionLimits: response[1]
      };
    })
    .catch(function(error) {
      console.log(error);
    });
}

function getCurrentPlan() {
  var payload = {
    isAjax: true
  }
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/plan/get', requestOptions)
    .then(response => response.json())
    .then(result => {
      const plansResponse = utils.parsePayload(result);

      return plansResponse;
    });
}

function getTransactionLimits() {
  var payload = {
    isAjax: true
  }
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/plan/getTxnAmtBal', requestOptions)
    .then(response => response.json())
    .then(result => {
      const plansResponse = utils.parsePayload(result);

      return plansResponse;
    });
}

function getWallet() {
  var payload = {
    isAjax: true,
    source: 'web'
  }

  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/wallet', requestOptions)
    .then(response => response.json())
    .then(result => {
      const walletResponse = utils.parsePayload(result);

      return walletResponse;
    });
}

function getPanlessHoldings() {
  var payload = {
    isAjax: true,
    source: 'iosApp',
    Platform: 'web'
  }

  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/ios/getPanLessHoldings', requestOptions)
    .then(response => response.json())
    .then(result => {
      const walletResponse = utils.parsePayload(result);

      return walletResponse;
    });
}

function getValidPans() {
  var payload = {
    isAjax: true
  }
  
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/users/getvalidpans', requestOptions)
    .then(response => response.json())
    .then(result => {
      const pansResponse = utils.parsePayload(result);

      return pansResponse;
    });
}

function setDefaultPan(pan) {
  var payload = {
    isAjax: true,
    pan: pan
  }
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/users/setpandefault', requestOptions)
    .then(response => response.json())
    .then(result => {
      const defaultPanResponse = utils.parsePayload(result);

      return defaultPanResponse;
    });
}

function deleteAccount(pan) {
  var payload = {
    isAjax: true,
    pan: pan
  }
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/users/deleteSubAccount', requestOptions)
    .then(response => response.json())
    .then(result => {
      const accountResponse = utils.parsePayload(result);

      return accountResponse;
    });
}

function activateAccount(pan) {
  var payload = {
    isAjax: true,
    pan: pan
  }
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/users/unDeleteSubAccount', requestOptions)
    .then(response => response.json())
    .then(result => {
      const accountResponse = utils.parsePayload(result);

      return accountResponse;
    });
}

function editAccount(name, nickName, pan, email, dob, can) {
  var payload = {
    isAjax: true,
    name: name,
    nickName: nickName,
    pan: pan,
    email: email,
    dob: dob,
    can: can
  }
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/users/updateSubAccount', requestOptions)
    .then(response => response.json())
    .then(result => {
      const accountResponse = utils.parsePayload(result);

      return accountResponse;
    });
}

function sendOtp(countryCode, mobile) {
  if (countryCode.split(' ').length > 1) {
    let spareCountryCode = countryCode.split(' ')[0];
    spareCountryCode = spareCountryCode.replace('(','').replace(')', '');
    countryCode = spareCountryCode;
  }
  
  var payload = {
    cCode: countryCode,
    mobile: mobile
  }

  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/auth/sendOtp', requestOptions)
    .then(response => response.json())
    .then(result => {
      const otpResponse = utils.parsePayload(result);

      return otpResponse;
    });
}

function verifyOtp(otp) {
  var payload = {
    otp: otp
  }

  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/auth/validateOtp', requestOptions)
    .then(response => response.json())
    .then(result => {
      const otpResponse = utils.parsePayload(result);

      return otpResponse;
    });
}

function setOrigin() {
  var payload = {
    // isAjax: true,
    origin: 'react'
  }

  if (window.$isAmazon) {
    payload["origin"] = process.env.REACT_APP_AMAZON_FESTIVAL_SOURCE
  }

  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/setUIRequestOrigin?value='+Math.random(), requestOptions)
    .then(response => response.json())
    .then(result => {
      const plansResponse = utils.parsePayload(result);

      return plansResponse;
    });
 }

 function assignPan(amfiCode, pan) {
  var payload = {
    pan: pan,
    AMFICode: amfiCode
  }

  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/ios/assignPan', requestOptions)
    .then(response => response.json())
    .then(result => {
      const pansResponse = utils.parsePayload(result);

      return pansResponse;
    });
  }

  function assignMultiPan(payload) {
    return middlewareService.postApiData('/ios/assignPanMulti', payload)
  }

 function sentUserData(source, offer, utm) {
  var payload = {
    Platform: source,
    offer: offer
  }
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      "X-product": `orobonds:` + offer
    },
    body: JSON.stringify(payload)
  };

  let url = '/users/intrestedInOffer';
  
  if (utm) url += utm;

  return fetch(process.env.REACT_APP_API_URL + url, requestOptions)
    .then(response => response.json())
    .then(result => {
      let pansResponse = utils.parsePayload(result);   

      return pansResponse;
    });
 }